import { fetchJson } from "@tree-company/discussit-embed";

const STORY_URLS = {
  nieuws:
    "https://tell-it-production-public.s3.eu-central-1.amazonaws.com/de0b403b40f4036f1829fc06/story.json",
  sensor:
    "https://tell-it-production-public.s3.eu-central-1.amazonaws.com/c431b344358daf8d8aadb880/story.json",
  stress:
    "https://tell-it-production-public.s3.eu-central-1.amazonaws.com/36fd34b9ef67218a9177198a/story.json",
  bubbel:
    "https://tell-it-production-public.s3.eu-central-1.amazonaws.com/6312858c44dd7241309ae16b/story.json",
  ocmw: "https://tell-it-production-public.s3.eu-central-1.amazonaws.com/64f0dab7d6b3b6006647b453/story.json",
  trainen:
    "https://tell-it-production-public.s3.eu-central-1.amazonaws.com/41c4b12375b02e0943b4490e/story.json",
  elektro:
    "https://tell-it-production-public.s3.eu-central-1.amazonaws.com/0e95d8326a22290829d03a73/story.json",
};

export async function fetchProject(url, { signal } = {}) {
  const { discuss_its: discussits } = await fetchJson(url, { signal });

  return [...discussits]
    .sort(() => Math.random() - 0.5)
    .map((discussit) => ({
      key: discussit.internal_key,
      configUrl: discussit.config_url,
      storyUrl: STORY_URLS[discussit.internal_key],
    }));
}
